export enum DisparityStage {
  ARREST = -1,
  CHARGING = -2,
  CONVICTION = -3,
  SENTENCING = -4,
}
